(function () {
  'use strict';

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var config = window.SMSRebuyCartConfig || {};
  var nativeCartRequired = false;
  var wholesaleCheckoutRequired = config.wholesaleCheckoutRequired === true;
  var blockedVariantIds = (config.blockedVariantIds || []).map(function (id) {
    return String(id);
  });
  var blockedProductHandles = (config.blockedProductHandles || []).map(function (handle) {
    return String(handle).toLowerCase();
  });
  var openingPromise = null;
  var originalFetch = window.fetch;

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function getSmartCart() {
    return window.Rebuy && window.Rebuy.SmartCart;
  }

  function smartCartIsReady() {
    var smartCart = getSmartCart();
    return Boolean(
      smartCart &&
      typeof smartCart.show === 'function' &&
      (smartCart.status === 'ready' || typeof smartCart.status === 'undefined')
    );
  }

  async function waitForSmartCart() {
    for (var attempt = 0; attempt < 50; attempt += 1) {
      if (smartCartIsReady()) return getSmartCart();
      await wait(100);
    }
    return null;
  }

  function syncCartCount(cart) {
    var shopifyCart = cart && cart.cart ? cart.cart : cart;
    if (!shopifyCart || typeof shopifyCart.item_count !== 'number') return;

    document.querySelectorAll('[data-sms-cart-count]').forEach(function (count) {
      count.textContent = shopifyCart.item_count;
      count.hidden = shopifyCart.item_count === 0;
    });
  }

  function closeNativeCart() {
    document.querySelectorAll('cart-drawer, cart-notification').forEach(function (cart) {
      if (typeof cart.close === 'function') {
        try {
          cart.close();
        } catch (error) {
          // The CSS guard in theme.liquid still prevents a native cart from appearing.
        }
      }
      cart.removeAttribute('open');
      cart.classList.remove('active', 'animate', 'is-active');
    });
  }

  function refreshRebuyCart() {
    return new Promise(function (resolve) {
      var rebuyCart = window.Rebuy && window.Rebuy.Cart;
      var finished = false;
      var finish = function (cart) {
        if (finished) return;
        finished = true;
        syncCartCount(cart || rebuyCart);
        resolve(cart || rebuyCart);
      };

      if (!rebuyCart || typeof rebuyCart.fetchShopifyCart !== 'function') {
        finish(rebuyCart);
        return;
      }

      try {
        var result = rebuyCart.fetchShopifyCart(finish);
        if (result && typeof result.then === 'function') {
          result.then(finish).catch(function () {
            finish(rebuyCart);
          });
        }
        window.setTimeout(function () {
          finish(rebuyCart);
        }, 800);
      } catch (error) {
        finish(rebuyCart);
      }
    });
  }

  function open(options) {
    options = options || {};

    if (openingPromise) return openingPromise;

    openingPromise = (async function () {
      closeNativeCart();

      var smartCart = await waitForSmartCart();
      if (!smartCart) {
        if (options.fallback !== false) window.location.assign(cartUrl);
        return false;
      }

      closeNativeCart();
      smartCart.show();
      refreshRebuyCart();
      return true;
    }()).catch(function () {
      if (options.fallback !== false) window.location.assign(cartUrl);
      return false;
    }).finally(function () {
      openingPromise = null;
    });

    return openingPromise;
  }

  function isPlainPrimaryClick(event) {
    return (
      event.button === 0 &&
      !event.defaultPrevented &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey
    );
  }

  function isCartLink(link) {
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return false;

    try {
      var target = new URL(link.href, window.location.href);
      var expected = new URL(cartUrl, window.location.origin);
      return target.origin === window.location.origin && target.pathname === expected.pathname;
    } catch (error) {
      return false;
    }
  }

  function isCartAddUrl(value) {
    if (!value) return false;

    try {
      var url = new URL(value, window.location.origin);
      return (
        url.origin === window.location.origin &&
        /\/cart\/add(?:\.js)?\/?$/.test(url.pathname)
      );
    } catch (error) {
      return false;
    }
  }

  function pushVariantId(ids, value) {
    if (value === null || typeof value === 'undefined') return;

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        pushVariantId(ids, item);
      });
      return;
    }

    if (typeof value === 'object') {
      if (Object.prototype.hasOwnProperty.call(value, 'id')) {
        pushVariantId(ids, value.id);
      }
      if (Object.prototype.hasOwnProperty.call(value, 'items')) {
        pushVariantId(ids, value.items);
      }
      return;
    }

    var normalized = String(value).trim();
    if (/^\d+$/.test(normalized)) ids.push(normalized);
  }

  function collectVariantIds(body) {
    var ids = [];
    if (!body) return ids;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      body.forEach(function (value, key) {
        if (key === 'id' || /\[id\]$/.test(key)) pushVariantId(ids, value);
      });
      return ids;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      body.forEach(function (value, key) {
        if (key === 'id' || /\[id\]$/.test(key)) pushVariantId(ids, value);
      });
      return ids;
    }

    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (!trimmed) return ids;

      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        try {
          pushVariantId(ids, JSON.parse(trimmed));
          return ids;
        } catch (error) {
          // Fall through to URL-encoded form parsing.
        }
      }

      try {
        return collectVariantIds(new URLSearchParams(trimmed));
      } catch (error) {
        return ids;
      }
    }

    if (typeof body === 'object') pushVariantId(ids, body);
    return ids;
  }

  function isBlockedVariantId(id) {
    return blockedVariantIds.indexOf(String(id)) !== -1;
  }

  function bodyContainsBlockedVariant(body) {
    return collectVariantIds(body).some(isBlockedVariantId);
  }

  function announceVerdantBlocked() {
    var message = document.getElementById('sms-verdant-cart-notice');

    if (!message) {
      message = document.createElement('div');
      message.id = 'sms-verdant-cart-notice';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.style.cssText = [
        'position:fixed',
        'left:50%',
        'bottom:24px',
        'z-index:2147483647',
        'max-width:min(430px,calc(100vw - 32px))',
        'transform:translateX(-50%)',
        'padding:13px 18px',
        'border:1px solid #b9d7ee',
        'border-radius:10px',
        'background:#ffffff',
        'box-shadow:0 12px 34px rgba(8,50,80,.18)',
        'color:#0b3558',
        'font:700 14px/1.4 Arial,sans-serif',
        'text-align:center'
      ].join(';');
      document.body.appendChild(message);
    }

    message.textContent = 'Verdant thermostats require a quote and cannot be added to the online cart.';
    window.clearTimeout(message.smsRemoveTimer);
    message.smsRemoveTimer = window.setTimeout(function () {
      if (message.parentNode) message.parentNode.removeChild(message);
    }, 5000);
  }

  function blockedCartAddResponse() {
    announceVerdantBlocked();

    var payload = JSON.stringify({
      status: 422,
      message: 'Request a quote for Verdant thermostats.',
      description: 'Verdant thermostats cannot be added to the online cart.'
    });

    if (typeof Response === 'function') {
      return Promise.resolve(new Response(payload, {
        status: 422,
        statusText: 'Unprocessable Entity',
        headers: { 'Content-Type': 'application/json' }
      }));
    }

    return Promise.reject(new Error('Verdant thermostats require a quote.'));
  }

  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : input && input.url;
      var method = String(
        (init && init.method) ||
        (input && input.method) ||
        'GET'
      ).toUpperCase();
      var context = this;
      var args = Array.prototype.slice.call(arguments);

      if (!isCartAddUrl(requestUrl) || method !== 'POST') {
        return originalFetch.apply(context, args);
      }

      if (init && Object.prototype.hasOwnProperty.call(init, 'body')) {
        if (bodyContainsBlockedVariant(init.body)) return blockedCartAddResponse();
        return originalFetch.apply(context, args);
      }

      if (typeof Request !== 'undefined' && input instanceof Request) {
        return input.clone().text().then(function (body) {
          if (bodyContainsBlockedVariant(body)) return blockedCartAddResponse();
          return originalFetch.apply(context, args);
        });
      }

      return originalFetch.apply(context, args);
    };
  }

  function getProductHandle(block) {
    var link = block && block.querySelector('a[href*="/products/"]');
    if (!link) return '';

    try {
      var path = new URL(link.href, window.location.origin).pathname.split('/products/')[1] || '';
      return path.split('/')[0].toLowerCase();
    } catch (error) {
      return '';
    }
  }

  function isBlockedProductBlock(block) {
    if (!block) return false;

    var handle = getProductHandle(block);
    if (
      blockedProductHandles.indexOf(handle) !== -1 ||
      handle.indexOf('verdant') !== -1
    ) {
      return true;
    }

    return /(^|\s)verdant(?:-|\s)/i.test(block.className || '');
  }

  function enhanceBlockedProductBlock(block) {
    if (!isBlockedProductBlock(block)) return;

    block.setAttribute('data-sms-verdant-blocked', 'true');

    block.querySelectorAll('button').forEach(function (button) {
      var label = (button.getAttribute('aria-label') || '').trim();
      var text = (button.textContent || '').trim();

      if (!/^add\b/i.test(label) && !/^add$/i.test(text)) return;

      button.setAttribute('data-sms-verdant-quote', 'true');
      button.setAttribute('aria-label', 'View Verdant quote options');
      var span = button.querySelector('span');
      if (span) span.textContent = 'Request a Quote';
      else button.textContent = 'Request a Quote';
    });
  }

  function enhanceBlockedRecommendations(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;

    if (root.matches && root.matches('.rebuy-product-block')) {
      enhanceBlockedProductBlock(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('.rebuy-product-block').forEach(enhanceBlockedProductBlock);
    }
  }

  function startRecommendationProtection() {
    enhanceBlockedRecommendations(document);

    if (typeof MutationObserver !== 'function') return;

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          enhanceBlockedRecommendations(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !isCartAddUrl(form.action)) return;

    if (bodyContainsBlockedVariant(new FormData(form))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      announceVerdantBlocked();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (!isPlainPrimaryClick(event)) return;

    var target = event.target;
    var checkoutButton = target.closest && target.closest('.rebuy-cart__checkout-button');

    if (wholesaleCheckoutRequired && checkoutButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(cartUrl + '?sms_wholesale_checkout=1');
      return;
    }

    var blockedBlock = target.closest && target.closest('.rebuy-product-block[data-sms-verdant-blocked="true"]');
    if (blockedBlock) {
      var quoteButton = target.closest('button[data-sms-verdant-quote="true"]');
      if (quoteButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var handle = getProductHandle(blockedBlock);
        window.location.assign(handle ? '/products/' + handle : '/pages/request-a-quote');
        return;
      }

      var addButton = target.closest('button');
      var addLabel = addButton && (addButton.getAttribute('aria-label') || '');
      if (addButton && (/^add\b/i.test(addLabel) || /^add$/i.test((addButton.textContent || '').trim()))) {
        event.preventDefault();
        event.stopImmediatePropagation();
        announceVerdantBlocked();
        return;
      }
    }

    var link = target.closest && target.closest('a[href]');
    if (!isCartLink(link) || nativeCartRequired) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);

  ['rebuy:cart.ready', 'rebuy:cart.add', 'rebuy:cart.change', 'rebuy:cart.enriched'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var cart = event.detail && event.detail.cart;
      syncCartCount(cart);
      enhanceBlockedRecommendations(document);

      if (
        eventName === 'rebuy:cart.add' &&
        !document.querySelector('.rebuy-cart.is-visible, .rebuy-cart[aria-hidden="false"]')
      ) {
        open({ fallback: false });
      }
    });
  });

  document.addEventListener('rebuy:smartcart.show', function () {
    closeNativeCart();
    enhanceBlockedRecommendations(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRecommendationProtection, { once: true });
  } else {
    startRecommendationProtection();
  }

  window.SMSRebuyCart = {
    open: open,
    closeNativeCart: closeNativeCart,
    syncCartCount: syncCartCount,
    isBlockedVariantId: isBlockedVariantId,
    nativeCartRequired: function () { return nativeCartRequired; },
    wholesaleCheckoutRequired: function () { return wholesaleCheckoutRequired; }
  };
}());
